(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (typeof document !== 'undefined') { root.PatchistryCuratedLooks = api; document.querySelectorAll('[data-curated-looks]').forEach(async el => { if (el.dataset.rotationSource) await api.rotate(el); api.mount(el); }); }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  function quantities(cart) {
    const map = new Map();
    for (const item of cart.items || []) map.set(String(item.variant_id || item.id), (map.get(String(item.variant_id || item.id)) || 0) + item.quantity);
    return map;
  }
  function confirmDelta(before, after, items) {
    const old = quantities(before), now = quantities(after), added = new Map();
    for (const item of items) added.set(String(item.id), (added.get(String(item.id)) || 0) + item.quantity);
    for (const id of new Set([...old.keys(), ...now.keys(), ...added.keys()])) {
      if ((now.get(id) || 0) !== (old.get(id) || 0) + (added.get(id) || 0)) return false;
    }
    return true;
  }
  function resolveVariant(product, item) {
    if (product.handle !== item.handle) throw new Error('Product identity changed. Please reload this page.');
    const variant = product.variants.find(v => String(v.id) === String(item.id));
    if (!variant) throw new Error('A selected variant is no longer listed. Choose individual items below.');
    if (!variant.available) throw new Error(product.title + ' is unavailable. Choose individual items below.');
    return variant;
  }
  function createController({request, refresh, root = '/'}) {
    let busy = false, uncertain = false;
    async function add(items) {
      if (busy || uncertain) return {kind: 'blocked'};
      busy = true;
      let sent = false;
      try {
        const current = await Promise.all(items.map(async item => ({item, product: await request(root + 'products/' + encodeURIComponent(item.handle) + '.js', {cache:'no-store'})})));
        let changed = false;
        for (const {item, product} of current) {
          const variant = resolveVariant(product, item);
          refresh(item, variant);
          if (variant.price !== item.price) changed = true;
        }
        if (changed) return {kind:'price-changed', message:'Prices have changed. Review the current prices, then add your selection again.'};
        const before = await request(root + 'cart.js', {cache:'no-store'});
        const payload = items.map(item => ({id:Number(item.id),quantity:1}));
        sent = true;
        let response;
        try { response = await request(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:payload})}); }
        catch (_) { /* A failed response may still have changed the cart. Reconcile once; never retry the write. */ }
        const after = await request(root + 'cart.js', {cache:'no-store'});
        if (confirmDelta(before, after, payload)) return {kind:'success',message:'Added ' + items.length + (items.length === 1 ? ' item' : ' items') + ' to your cart.'};
        uncertain = true;
        return {kind:'uncertain',message:'We couldn’t add this look. Your cart has not been confirmed. Please check your cart before trying again.'};
      } catch (error) {
        if (sent) uncertain = true;
        return {kind:sent ? 'uncertain' : 'error',message:sent ? 'Your cart has not been confirmed. Please check your cart before trying again.' : error.message};
      } finally {busy = false;}
    }
    return {add, get busy(){return busy;},get uncertain(){return uncertain;}};
  }
  async function rotate(el) {
    const status = el.querySelector('[data-status]');
    const grid = el.querySelector('.cl-grid');
    const root = el.dataset.root.replace(/\/?$/, '/');
    const request = async url => { const r=await fetch(url,{credentials:'same-origin',cache:'no-store'}); if(!r.ok)throw Error('Selection could not be verified');return r.json(); };
    try {
      const pool = await request(el.dataset.rotationSource);
      let storage;try{storage=sessionStorage;}catch(_){}
      const picker = globalThis.PatchistryCuratedRotation.createVisitPicker({pool,storage,currency:el.dataset.currency,fetchProduct:handle=>request(root+'products/'+encodeURIComponent(handle)+'.js')});
      const result = await picker.select();
      const format = cents => new Intl.NumberFormat(undefined,{style:'currency',currency:result.currency||'USD'}).format(cents/100);
      const make=(tag,cls,text)=>{const node=document.createElement(tag);if(cls)node.className=cls;if(text)node.textContent=text;return node;};
      const fragment=document.createDocumentFragment();
      for(const look of result.looks){
        const card=make('article','cl-card');card.dataset.look='';card.dataset.lookId=look.id;
        card.append(make('p','cl-kicker','One hat + two separate patches'),make('h2','',look.name),make('p','cl-card-copy',look.whyItWorks));
        const list=make('ul','cl-items');
        for(const item of look.items){
          const row=make('li','cl-item');Object.assign(row.dataset,{item:'',handle:item.handle,variant:String(item.id),price:String(item.price)});
          const url=root+'products/'+encodeURIComponent(item.handle)+'?variant='+item.id;
          const art=make('a');art.href=url;art.tabIndex=-1;art.setAttribute('aria-hidden','true');
          const image=make('img');image.src=item.image;image.alt=item.title;image.width=160;image.height=180;image.loading='lazy';art.append(image);
          const info=make('div');const name=make('a','cl-item-name',item.role==='hat'?'Shop the hat':item.title.split(' | ')[0]);name.href=url;
          const detail=item.role==='hat'?item.title.split(' | ')[0]+' · adjustable snapback':item.role==='signature'?'Signature · 2.5 inches at longest point':'Candyz · 1 inch at longest point';
          const price=make('p','cl-detail',format(item.price));price.dataset.itemPrice='';
          const button=make('button','','Add');button.type='button';button.dataset.addOne='';button.setAttribute('aria-label','Add '+item.title);button.disabled=true;
          info.append(name,make('p','cl-detail',detail),price,button);row.append(art,info);list.append(row);
        }
        const all=make('button','cl-add-all');all.type='button';all.dataset.addAll='';all.disabled=true;all.append(document.createTextNode('Add all 3 items — '));const total=make('span','',format(look.totalCents));total.dataset.total='';all.append(total);
        card.append(list,all);fragment.append(card);
      }
      grid.replaceChildren(fragment);
      if(!result.looks.length)status.textContent='These looks are temporarily unavailable. Please explore the individual products.';
      else if(result.looks.length<3)status.textContent='Some looks are temporarily unavailable. Here are the complete looks available now.';
      el.addEventListener('click',()=>picker.touch());
      el.dataset.rotationReady='true';
    } catch (_) {
      grid.replaceChildren();status.textContent='We couldn’t verify the current looks. Please reload to try again.';el.dataset.rotationReady='error';
    }
  }
  function mount(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = 'true';
    const root = el.dataset.root.replace(/\/?$/, '/');
    const format = cents => new Intl.NumberFormat(undefined,{style:'currency',currency:el.dataset.currency || 'USD'}).format(cents / 100);
    const status = el.querySelector('[data-status]');
    const rows = [...el.querySelectorAll('[data-item]')];
    const buttons = [...el.querySelectorAll('button')];
    const read = row => ({handle:row.dataset.handle,id:row.dataset.variant,price:Number(row.dataset.price)});
    function totals() {
      el.querySelectorAll('[data-look]').forEach(card => {
        const items = [...card.querySelectorAll('[data-item]')];
        card.querySelector('[data-total]').textContent = format(items.reduce((n,row) => n + Number(row.dataset.price),0));
      });
    }
    function refresh(item, variant) {
      rows.filter(row => row.dataset.variant === String(item.id)).forEach(row => {
        row.dataset.price = variant.price;
        row.dataset.available = String(variant.available);
        row.querySelector('[data-item-price]').textContent = format(variant.price);
      });
      totals();
    }
    async function request(url, options) {
      const response = await fetch(url,{credentials:'same-origin',...options});
      if (!response.ok) throw new Error('We couldn’t verify this selection. Please check your cart before trying again.');
      return response.json();
    }
    const controller = createController({request,refresh,root});
    function controls() {
      for (const button of buttons) {
        const row = button.closest('[data-item]');
        const unavailable = row ? row.dataset.available !== 'true' : [...button.closest('[data-look]').querySelectorAll('[data-item]')].some(r => r.dataset.available !== 'true');
        button.disabled = controller.busy || controller.uncertain || unavailable;
      }
    }
    rows.forEach(row => {row.dataset.available = 'false';});
    controls();
    buttons.forEach(button => button.addEventListener('click', async () => {
      const selected = button.hasAttribute('data-add-one') ? [button.closest('[data-item]')] : [...button.closest('[data-look]').querySelectorAll('[data-item]')];
      const promise = controller.add(selected.map(read));
      controls();status.textContent = 'Checking current availability and prices…';
      const result = await promise;
      if (result.kind !== 'blocked') status.textContent = result.message;
      controls();
      if (!button.disabled) button.focus({preventScroll:true});
      else {status.tabIndex = -1;status.focus({preventScroll:true});}
    }));
    Promise.all([...new Set(rows.map(row => row.dataset.handle))].map(async handle => {
      const product = await request(root + 'products/' + encodeURIComponent(handle) + '.js',{cache:'no-store'});
      for (const row of rows.filter(r => r.dataset.handle === handle)) {
        const item = read(row);
        const variant = product.variants.find(v => String(v.id) === item.id);
        if (product.handle !== handle || !variant) throw new Error('A selected variant is no longer listed.');
        refresh(item,variant);
        if (!variant.available) status.textContent = product.title + ' is unavailable. Choose individual items below.';
      }
    })).then(controls).catch(error => {status.textContent = error.message;controls();});
  }
  return {quantities,confirmDelta,resolveVariant,createController,mount,rotate};
});
